import React from 'react';
import classSetter from 'classnames';
const Label = (props) => {
    const { visible, ...otherProps } = props;
    const classes = {
        label: true,
        'no-display': visible === true
    };
    if (props.type === 'span') {
        return (React.createElement("span", { ...otherProps, className: classSetter(classes, props.className), style: props.style }, props.children));
    }
    else {
        return (React.createElement("label", { ...otherProps, className: classSetter(classes, props.className), style: props.style }, props.children));
    }
};
Label.defaultProps = {
    type: 'span'
};
export default Label;
